import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setActiveTab } from "slices/userAdmin/userAdminSlice";
import { fetchLicenseInfo } from "slices/userAdmin/actions/license";
import LicenseSystemWideInfo from "layout/userAdmin/license/LicenseSystemWideInfo";
import LicenseWorkspaceInfo from "layout/userAdmin/license/LicenseWorkspaceInfo";

const LicenseContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveTab(1));
    dispatch(fetchLicenseInfo());
  }, []);

  return (
    <div className="license__content" data-testid="license-content">
      <LicenseSystemWideInfo />
      <LicenseWorkspaceInfo />
    </div>
  );
};

export default LicenseContent;
